import React, { useEffect, useState } from 'react';
import '../../assets/css/user-verification.css';
import LogoImg from '../../assets/images/Layer 2.svg';
import Api from '../../helper/Api';
import { useParams } from 'react-router-dom';

export default function UserVerification() {
  const [isVerified, setIsVerified] = useState(null); // null means loading or undetermined
  const [isVerificationExpired, setIsVerificationExpired] = useState(false);

  const { token } = useParams();

  // This could be replaced with an actual API call or logic to check the verification status
  useEffect(() => {
    Api('GET', `user/verify_email/${token}`, null, 'application/json')
      .then((response) => {
        if (response.data.status === 1) {
          setIsVerified(true);
        } else {
          setIsVerified(false);
          setIsVerificationExpired(true);
        }
      })
      .catch((error) => {
        setIsVerified(false);
      });
  }, [token]);

  if (isVerified === null) {
    return <div>Loading...</div>; // or a loading spinner
  }

  return (
    <div className='user-verification-container'>
      <div className='main-content'>
        <div className='text-content'>
          <div className='logo-img'>
            <img src={LogoImg} alt='Kyulebag' />
          </div>
          {/* Left content goes here, e.g., text, forms, etc. */}
          {isVerified ? (
            <>
              <h1>Account Verified!</h1>
              <p>
                Congratulations, your account has been successfully verified!
              </p>
              <p>
                Now you may logon to the Kyulebag mobile app. Wishing you a 'Kyule' ( cool ) experience.
              </p>
            </>
          ) : isVerificationExpired ? (
            <>
              <h1>Verification Expired</h1>
              <p>Unfortunately, your verification link has expired.</p>
            </>
          ) : (
            <>
              <h1>Verification Error</h1>
              <p>
                Something went wrong on our end, and we were unable to verify
                your account at this time.
              </p>
            </>
          )}
        </div>
        {/* <div className='right-content'>
          <img src={BackgruondImg} alt='Background' />
        </div> */}
      </div>
    </div>
  );
}
